module.exports = __webpack_public_path__ + "static/foto_praktijk_1_comp-cbf5fc6a0eaf5d7be43c0cee2926c6cb.jpeg";